import axios from "axios";
import config from "../../../config";

/**
 * POST api/v1/customer-portal/appointments
 * Body: { page?: number, per_page?: number, status?: 'all'|'pending'|'confirmed'|'completed',
 *         focus_appointment_id?: number }
 */
export function fetchCustomerPortalAppointments(token, body = {}) {
  return axios.post(`${config.API_URL}customer-portal/appointments`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * POST api/v1/customer-portal/appointments/cancel-context
 * Body: { appointment_id: number }
 */
export function fetchCustomerPortalCancelContext(token, appointmentId) {
  return axios.post(
    `${config.API_URL}customer-portal/appointments/cancel-context`,
    { appointment_id: appointmentId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

/**
 * POST api/v1/customer-portal/appointments/cancel
 * Body: { appointment_id: number }
 */
export function cancelCustomerPortalAppointment(token, payload) {
  const body =
    typeof payload === "number" || typeof payload === "string"
      ? { appointment_id: Number(payload) }
      : payload;

  return axios.post(`${config.API_URL}customer-portal/appointments/cancel`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    // Staging can keep the socket open after the 200 body while emails run.
    // Fail/settle within a minute so the UI is never stuck indefinitely.
    timeout: 60000,
  });
}
